import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './commonModal.css'

function CommonModal(props) {
  // Support both old API (Form prop) and new API (children, onSave, onCancel, title)
  const title = props.title || 'Add Order';
  const formContent = props.Form || props.children;
  const hasSaveButton = props.onSave !== undefined;
  const hasCancelButton = props.onCancel !== undefined;

  return (
    <Modal
      show={props.show}
      onHide={props.onHide || props.onCancel}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
         {formContent}
      </Modal.Body>
      <Modal.Footer>
        {hasCancelButton && (
          <Button variant="secondary" onClick={props.onCancel || props.onHide}>
            Cancel
          </Button>
        )}
        {hasSaveButton && (
          <Button variant="primary" onClick={props.onSave}>
            {props.saveButtonText || 'Save'}
          </Button>
        )}
        {!hasSaveButton && !hasCancelButton && (
          <Button onClick={props.onHide}>Close</Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default CommonModal;
